import Vue from "vue";
import Endpoints from "@/share/Endpoints";

/* ============================================================================
 * Admin: CRUD
 * ========================================================================== */

export const fetchProductsServices = async ({ commit }, params = {}) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productsServices,
      method: "GET",
      params,
    });
    commit("SET_PRODUCTS_SERVICES_LIST", data.productsServices);
    return { status: true, data: data.productsServices };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const fetchProductServiceById = async ({ commit }, id) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServiceById.replace(":id", id),
      method: "GET",
    });
    commit("SET_SELECTED_PRODUCT_SERVICE", data.productService);
    return { status: true, data: data.productService };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const createProductService = async ({ commit }, productService) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productsServices,
      method: "POST",
      data: { productService },
    });
    commit("SET_SELECTED_PRODUCT_SERVICE", data.productService);
    return { status: true, data: data.productService };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const updateProductService = async ({ commit }, { id, productService }) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServiceById.replace(":id", id),
      method: "PUT",
      data: { productService },
    });
    commit("SET_SELECTED_PRODUCT_SERVICE", data.productService);
    return { status: true, data: data.productService };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const deleteProductService = async (_ctx, id) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServiceById.replace(":id", id),
      method: "DELETE",
    });
    return { status: true, data };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

/* ============================================================================
 * Acciones de ciclo de vida
 * ========================================================================== */

export const publishProductService = async ({ commit }, id) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServicePublish.replace(":id", id),
      method: "POST",
    });
    commit("SET_SELECTED_PRODUCT_SERVICE", data.productService);
    return { status: true, data: data.productService };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const pauseProductService = async ({ commit }, id) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServicePause.replace(":id", id),
      method: "POST",
    });
    commit("SET_SELECTED_PRODUCT_SERVICE", data.productService);
    return { status: true, data: data.productService };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const archiveProductService = async ({ commit }, id) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServiceArchive.replace(":id", id),
      method: "POST",
    });
    commit("SET_SELECTED_PRODUCT_SERVICE", data.productService);
    return { status: true, data: data.productService };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const uploadProductServiceBanner = async ({ commit }, { id, file }) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const { data } = await Vue.axios({
      url: Endpoints.productServiceUploadBanner.replace(":id", id),
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
    commit("SET_SELECTED_PRODUCT_SERVICE", data.productService);
    return { status: true, data };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const uploadProductServiceGalleryImage = async ({ commit }, { id, file }) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const { data } = await Vue.axios({
      url: Endpoints.productServiceUploadGallery.replace(":id", id),
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
    commit("SET_SELECTED_PRODUCT_SERVICE", data.productService);
    return { status: true, data };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const removeProductServiceGalleryImage = async ({ commit }, { id, imageUrl }) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServiceRemoveGalleryImage.replace(":id", id),
      method: "DELETE",
      data: { imageUrl },
    });
    commit("SET_SELECTED_PRODUCT_SERVICE", data.productService);
    return { status: true, data };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

/* ============================================================================
 * Público / Miembro
 * ========================================================================== */

export const fetchPublicProductService = async ({ commit }, slug) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServicePublicBySlug.replace(":slug", slug),
      method: "GET",
    });
    commit("SET_PUBLIC_PRODUCT_SERVICE", data.productService);
    return { status: true, data: data.productService };
  } catch (error) {
    commit("SET_PUBLIC_PRODUCT_SERVICE", null);
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const fetchPublicProductServiceById = async ({ commit }, id) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServicePublicById.replace(":id", id),
      method: "GET",
    });
    commit("SET_PUBLIC_PRODUCT_SERVICE", data.productService);
    return { status: true, data: data.productService };
  } catch (error) {
    commit("SET_PUBLIC_PRODUCT_SERVICE", null);
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const fetchMemberProductsServices = async ({ commit }) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServicesForMember,
      method: "GET",
    });
    commit("SET_MEMBER_PRODUCTS_SERVICES", data.productsServices);
    return { status: true, data: data.productsServices };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const fetchProductServiceOrders = async (_ctx, { id, params = {} }) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.productServiceOrders.replace(":productServiceId", id),
      method: "GET",
      params,
    });
    return { status: true, data };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const fetchMemberProductOrders = async () => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.memberProductServiceOrders,
      method: "GET",
    });
    return { status: true, data };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};

export const markOrderAsDelivered = async (_ctx, orderId) => {
  try {
    const { data } = await Vue.axios({
      url: Endpoints.markOrderDelivered.replace(":orderId", orderId),
      method: "PUT",
    });
    return { status: true, data };
  } catch (error) {
    return { 
      status: false, 
      message: error?.response?.data?.error?.message || error?.response?.data?.message || error.message 
    };
  }
};
